import { useState } from 'react'
import { useProfile } from '../lib/hooks'
import { PLAN_START_DATE } from '../data/plan'

export default function StartDatePrompt() {
  const { setStartDate } = useProfile()
  const [date, setDate] = useState(PLAN_START_DATE)

  return (
    <div className="login-page">
      <div className="login-brand-panel">
        <img src="/health-icons/icon-512.png" alt="" className="login-brand-mark" />
        <h2 className="login-brand-title">HealthNest</h2>
        <p className="login-brand-tagline">Your 90-day plan, tracked in full - workouts, meals, macros, and progress, all in one place.</p>
        <ul className="login-brand-features">
          <li>Full macro + micronutrient tracking</li>
          <li>Workout logging with personal records</li>
          <li>Pantry &amp; shopping list management</li>
          <li>Progress photos and weekly reviews</li>
        </ul>
      </div>
      <div className="login-form-side">
        <div className="login-card">
          <h1>Let's begin</h1>
          <p className="muted">Your plan's Day 1 is Monday 28 Sep 2026 - every menu and workout is mapped to real calendar dates. Change it only if you're starting on a different day.</p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 14, marginTop: 18 }}>
            <label>
              Start date
              <input type="date" value={date} onChange={(e) => setDate(e.target.value)} />
            </label>
            <button className="btn btn-primary full-width" onClick={() => setStartDate(date)}>
              Start my plan
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
